import { render, staticRenderFns } from "./wxForm.vue?vue&type=template&id=47a083c0&scoped=true&"
import script from "./wxForm.vue?vue&type=script&lang=js&"
export * from "./wxForm.vue?vue&type=script&lang=js&"
import style0 from "./wxForm.vue?vue&type=style&index=0&id=47a083c0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47a083c0",
  null
  
)

export default component.exports